// extracted by mini-css-extract-plugin
module.exports =  {"actions":"M23Sd7D3WBKC0_4tXsWQ"};